import { ComboItem } from '../../../../model';
import { RegionEditIn, RegionEditOut } from '../../../../model/seguridad';
import Common, { Stores } from '../../../common';
import { IPaginatedResponse, IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';
import { IRegion } from '../model';

export default class RegionService extends ServiceBase {
  getEdit = (data:{ id?: number }) => this.GetFetch<IResponse<RegionEditOut>>('entity/region/edit', data);
  
  combo = (data:{ activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<IResponse<ComboItem[]>>('entity/region/combo', data);

  upsert = (data:RegionEditIn) => this.PostFetch<IResponse<number>>('entity/region', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: number, nombre?: string, activo?: boolean }) : Promise<IPaginatedResponse<IRegion>> => 
    this.GetFetch<IPaginatedResponse<IRegion>>('entity/region/find', data);

  all = () : Promise<IResponse<IRegion[]>> => 
    Common.indexedDB.StoreControl.apiget(Stores.Regiones, () => this.GetFetch<IResponse<IRegion[]>>('entity/region/all', {}));

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/region', data);  
}